<template>
  <div>
    <Row justify="center" type="flex" style="background: #ffffff">
      <Col span="24">
        <img
          style="width: 100%; height: 482px"
          src="../../../static/img/coreBusiness/head_img.png"
          alt="#"
        />
        <div class="banner_font">
          <div class="banner_font1">携手走进5G物联新时代</div>
          <div class="banner_font2">
            <div>智慧物联</div>
            <div style="margin: 0 0 0 4%">携手共进</div>
          </div>
        </div>
      </Col>
      <Col span="24" class="ContactUs_1"> </Col>
      <Col span="24" class="ContactUs_2"> </Col>
      <Col span="24" class="ContactUs_3"> </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.ContactUs_1 {
  height: 669px;
  background-image: url("../../../static/img/coreBusiness/bj_img.png");
  background-size: 100% 100%;
}

.ContactUs_2 {
  height: 890px;
  background-image: url("../../../static/img/coreBusiness/bj_img2.png");
  background-size: 100% 100%;
}

.ContactUs_3 {
  height: 485px;
  background-image: url("../../../static/img/coreBusiness/bj_img3.png");
  background-size: 100% 100%;
}

/deep/ .ivu-form-item-content {
  margin-left: 20%;
}

/deep/ .ivu-input {
  width: 80%;
}

.ContactUs_form >>> textarea.ivu-input {
  height: 140px;
}

#btn {
  background-image: linear-gradient(to right, #1b1bc4, #cf1818);
  border: none;
  width: 100px;
  color: #ffffff;
  height: 40px;
  font-size: 17px;
  margin-bottom: 10px;
}

.banner_font {
  width: 550px;
  height: 190px;
  position: absolute;
  margin: -15% 0 0 10%;
}
.banner_font1 {
  height: 37px;
  font-size: 30px;
  font-family: OPPOSans;
  font-weight: 400;
  color: #fff;
  text-align: center;
}

.banner_font2 {
  margin-top: 2%;
  margin-left: 22%;
  font-size: 23px;
  display: flex;
  width: 550px;
  color: #fff;
  font-family: OPPOSans;
}
</style>



// WEBPACK FOOTER //
// src/components/coreBusiness/propertyManagement.vue